// src/components/community/ThreadList.js
import React, { useRef, useEffect } from 'react';
import ThreadItem from './ThreadItem';

const ThreadList = ({ threads, loading, error, hasMore, onLoadMore, onThreadClick }) => {
  // Reference for infinite scrolling
  const observerRef = useRef(null);
  const lastThreadRef = useRef(null);
  const isMounted = useRef(true);

  // Set up mounted ref
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Set up infinite scroll with Intersection Observer
  useEffect(() => {
    if (loading) return;
    
    if (observerRef.current) observerRef.current.disconnect();
    
    observerRef.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore && isMounted.current) {
        onLoadMore();
      }
    });
    
    if (lastThreadRef.current) {
      observerRef.current.observe(lastThreadRef.current);
    }
    
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [loading, hasMore, onLoadMore]);

  if (error) {
    return (
      <div className="thread-list-error">
        <p>{error}</p>
        <button onClick={onLoadMore}>Try Again</button>
      </div>
    );
  }

  return (
    <div className="thread-list">
      {threads.length === 0 && !loading ? (
        <div className="no-threads">
          <p>No discussions found in this category. Start a new thread!</p>
        </div>
      ) : (
        <>
          {threads.map((thread, index) => (
            <div 
              key={thread.id} 
              ref={index === threads.length - 1 ? lastThreadRef : null}
            >
              <ThreadItem 
                thread={thread}
                onClick={onThreadClick}
                // Removed onTagClick prop
              />
            </div>
          ))}
          
          {loading && (
            <div className="loading-threads">
              <div className="spinner"></div>
              <p>Loading threads...</p>
            </div>
          )}
          
          {!loading && hasMore && threads.length > 0 && (
            <button 
              className="load-more-btn"
              onClick={() => isMounted.current && onLoadMore()}
            >
              Load More
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ThreadList;